import { FC, HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Flex, theme } from 'antd';

import { IBrand, useBrandsSlice } from 'entities/Brand';
import { IOffer } from 'entities/Offer/model/types';

import { OfferTitle } from '../OfferTitle/OfferTitle';

interface IOfferCardJoinProps extends HTMLAttributes<HTMLDivElement> {
	offer: IOffer;
	brand: IBrand;
}

export const OfferCardJoin: FC<IOfferCardJoinProps> = ({ offer, brand, ...props }) => {
	const { t } = useTranslation();
	const {
		token: { colorBorderSecondary },
	} = theme.useToken();
	const { setOpenedOffer } = useBrandsSlice();

	return (
		<Flex
			{...props}
			justify="space-between"
			align="center"
			gap={12}
			style={{ padding: '10px 0', borderBottom: `1px dashed ${colorBorderSecondary}` }}>
			<OfferTitle offer={offer} />

			<Button variant="text" color="primary" size="small" onClick={() => setOpenedOffer({ offer, brand })}>
				{t('Подробнее')}
			</Button>
		</Flex>
	);
};
